import { Link } from "react-router-dom"

const Footer =()=>{
    return (
        <div id="footer" style={{background:"#2d2828"}}>
        <div className="container text-center">
          <p style={{color:"#fff"}}>
            All Rights Reserved.© {new Date().getFullYear()} <Link to="/">TheAccountExpress</Link>{" "}
            {/* <a href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a> */}
          </p>
        </div>
      </div>
    )
}

export default Footer